<script>
  import { PHP, notificationsList, alert } from "../store";
  import Header from "./Header.svelte";
  import Row from "./Row.svelte";
  import Pagination from "./Pagination.svelte";
  import { onMount } from "svelte";
  import axios from "axios";
  import CircleLoader from "../utils/CircleLoader.svelte";
  import Placeholder from "../utils/Placeholder.svelte";
  import { retrieveNotifications } from "../api";
  import to from "await-to-js";

  $: isLoading = false;

  const limit = 12;
  let offset = 0;

  $: hasNext = $notificationsList.length >= limit;
  $: hasPrev = offset >= limit;

  const getNotifications = async (next, init = false) => {
    if (!init) {
      offset = next === 1 ? offset + limit : offset - limit;
    }

    // To replace all previous list first make it empty
    isLoading = true;

    const [error, response] = await to(
      retrieveNotifications({
        limit,
        offset
      })
    );

    isLoading = false;

    if (response) notificationsList.update(l => (l = [...response.data.results]));
  };

  onMount(async () => {
    if ($PHP.isActivated) await getNotifications(1, true);
  });
</script>

<style>
  .table-container {
    min-height: 250px;
    position: relative;
  }
</style>

<div class="container is-fluid">
  <div class="table-container">
    <div class="notification">
      <table class="table is-fullwidth is-striped is-narrow is-hoverable">

        <Header />
        {#if isLoading}
          <CircleLoader />
        {:else}
          <tbody>
            {#each $notificationsList as notification, i (notification.wrapper_id)}
              <Row {notification} {getNotifications} />
            {/each}
          </tbody>
        {/if}

      </table>

      {#if $notificationsList.length === 0 && !isLoading}
        <Placeholder text="No notification found" , icon="exclamation" />
      {/if}

      <Pagination
        hasNext={hasNext && !isLoading}
        hasPrev={hasPrev && !isLoading}
        onNext={() => !isLoading && getNotifications(1)}
        onPrev={() => !isLoading && getNotifications(-1)} />
    </div>

  </div>
</div>
